module.exports = __webpack_public_path__ + "img/cat-what.71011f05.gif";